import ShareableLinkLastName from './ShareableLinkLastName.component';

export default ShareableLinkLastName;
